import {
  RUN_VIEW_TYPE,
  SingleRunWorkspaceWorkspaceProps,
} from '../../pages/Run/types';
import {usePropsSelector} from '../../state/hooks';
import * as WorkspaceSelectors from '../../state/workspaces/selectors';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {useInitWorkspaceAndHandleUrlChanges} from '../../state/workspaces/url';
import {EMPTY_PANEL_BANK_CONFIG} from '../../util/panelbankConfigs';
import {EMPTY_SINGLE_TAB} from '../../util/panels';
import * as PanelTypes from '../../util/panelTypes';
import {OrganizedSettings, PanelBankConfig} from '../PanelBank/types';
import {EMPTY_SETTINGS} from '../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {Settings} from '../WorkspaceDrawer/Settings/types';

export type ViewType = 'project-view' | 'sweep-view' | 'group-view';
export type RecommendGrouping = 'group-and-jobtype' | 'jobtype';

export interface RunPagePersistentState {
  settings: Settings;
  panels: PanelTypes.Config;
  panelBankConfig: PanelBankConfig;
  customExpanded: boolean;
  libraryExpanded: boolean;
  /** @deprecated may still be saved on some view specs but is no longer used in app */
  slowWarningHiddenAt?: string;
  cliVersionWarningHiddenAt?: string;
  panelAutoGenInfoHiddenAt?: string;
  workspaceSettings: OrganizedSettings;
}
export const EMPTY_VIEW_STATE: RunPagePersistentState = {
  panels: EMPTY_SINGLE_TAB,
  panelBankConfig: EMPTY_PANEL_BANK_CONFIG, // spec for PanelBank
  settings: EMPTY_SETTINGS,
  workspaceSettings: {},
  customExpanded: false,
  libraryExpanded: true,
};

export const useSingleRunWorkspaceProps = (
  args: SingleRunWorkspaceWorkspaceProps
): WorkspaceSelectors.WorkspaceStatusOrData<
  WorkspaceSelectors.SingleRunWorkspacePageData &
    WorkspaceSelectors.GenericWorkspacePageData & {
      workspaceID: string;
    }
> => {
  const workspaceStateId = useInitWorkspaceAndHandleUrlChanges({
    entityName: args.entityName,
    projectName: args.projectName,
    viewType: RUN_VIEW_TYPE,
    defaultSpec: EMPTY_VIEW_STATE,
  });

  const runPageData = usePropsSelector(
    WorkspaceSelectors.makeRunWorkspaceSelector,
    workspaceStateId
  );
  if (WorkspaceSelectors.getStatus(runPageData) !== 'ready') {
    return runPageData as WorkspaceSelectors.WorkspaceStatus;
  }

  if (!runPageData || !workspaceStateId) {
    console.error(
      'invalid state - workspace or workspaceID not set after loading'
    );
    return {
      status: 'error',
      error: {
        errorCode: '404',
        userTitle: 'Error loading run workspace',
        userMessage: 'This run workspace could not be loaded.',
      },
    };
  }

  return {...runPageData, workspaceID: workspaceStateId};
};
